import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/company/_layout/home/')({
  component: () => <div>Hello /company/_layout/home/!</div>
})